import {
  fallbackSucursales,
  FORMATO_SUPER_KOMPRAS,
  FORMATO_SURTITIENDA,
  FORMATO_ACROPOLIS,
} from "@/composables/useSucursales";

export default {
  computed: {
    tiendasDisponibles() {
      if (this.$store?.state?.tiendas?.tiendas?.length) {
        return this.$store.state.tiendas.tiendas;
      }
      return fallbackSucursales;
    },
    sucursalesSk() {
      return this.tiendasDisponibles.filter(
        (tienda) =>
          tienda.formato === FORMATO_SUPER_KOMPRAS &&
          (!tienda.categoria || tienda.categoria === "sk")
      );
    },
    sucursalesSkMicro() {
      return this.tiendasDisponibles.filter(
        (tienda) =>
          tienda.formato === FORMATO_SUPER_KOMPRAS &&
          tienda.categoria === "sk-micro"
      );
    },
    sucursalesSurtitienda() {
      return this.tiendasDisponibles.filter(
        (tienda) => tienda.formato === FORMATO_SURTITIENDA
      );
    },
    sucursalesAcropolis() {
      return this.tiendasDisponibles.filter(
        (tienda) => tienda.formato === FORMATO_ACROPOLIS
      );
    },
  },
  created() {
    if (!this.$store) {
      return;
    }

    this.$store.dispatch("tiendas/iniciarSuscripcion");
    if (!this.$store.state.tiendas?.tiendas?.length) {
      this.$store.dispatch("tiendas/recargarTiendas").catch(() => {});
    }
  },
  methods: {
    obtenerSucursalPorDivision(division) {
      return this.tiendasDisponibles.find(
        (tienda) => String(tienda.division) === String(division)
      );
    },
  },
};

